import { Chart } from 'chart.js';
import { isMobile } from './../utilities/detection';

let _fontSize = 16;
let _lineHeight = 2.5;
let _fontColor = '#000000';
let _fontFamily =  'Folio,sans-serif';

export function createChart(canvas : HTMLCanvasElement, xAxisData : string[], yAxisData : Dataset[]) {
    const displayYAxis =   isMobile() == false;
    myOptions.scales.yAxes[0].ticks.display = displayYAxis;
    let chart : Chart = new Chart(canvas.getContext('2d'), {
        
        // The type of chart we want to create
        type: 'line',

        // The data for our dataset
        data: {
            labels: xAxisData,
            datasets: yAxisData
        },

        // Configuration options go here
        options: myOptions
    });
    return chart;
}

export function handleResize(chart : Chart, size) {
    const displayYAxis =  isMobile() == false;
    myOptions.scales.yAxes[0].ticks.display = displayYAxis;
    chart.options = myOptions;
}

export default class Dataset {
    label: string; 
    backgroundColor: string;
    borderColor: string;
    data: number[];
}

//options
let myOptions = {
    responsive: true,
    maintainAspectRatio: true,
    layout: {
        padding: {
            //left is handled in less file
            left: 0,
            right: 30,
            top: 30,
            bottom: 30
        }
    },
    showTooltips: true,
    tooltips: {
        enabled: true,
        cornerRadius: 0,
        backgroundColor: 'rgba(255,255,255)',
        bodyFontFamily: _fontFamily,
        bodyFontColor: _fontColor,
        bodyFontStyle: '300',
        titleFontColor: _fontColor,
        titleFontStyle: 'normal',
        titleFontFamily: _fontFamily,
        callbacks: {
            label: function(tooltipItem, data) {
                var label = data.datasets[tooltipItem.datasetIndex].label || '';

                if (label) {
                    label += ': ';
                }
                // Convert the number to a string and splite the string every 3 charaters from the end
                let value = tooltipItem.yLabel;
                value = value.toString();
                value = value.split(/(?=(?:...)*$)/);
                
                // Convert the array to a string and format the output
                value = value.join('\'');
                value = 'CHF ' + value;
                label += value
                return label;
            }
        }

    },
    scales: {
        xAxes: [{
            ticks: {
                fontFamily: _fontFamily,
                fontSize: _fontSize,
                lineHeight: _lineHeight,
                fontColor: _fontColor,
                fontStyle: '300'
            }, 
            gridLines: {
                display:false
            },
        }],
        yAxes: [{
            ticks: {

                // Return an empty string to draw the tick line but hide the tick label
                // Return `null` or `undefined` to hide the tick line entirely
                userCallback: function(value, index, values) {
                    // Convert the number to a string and splite the string every 3 charaters from the end
                    value = value.toString();
                    value = value.split(/(?=(?:...)*$)/);
                    
                    // Convert the array to a string and format the output
                    value = value.join('\'');
                    return 'CHF ' + value;
                },
                fontFamily: _fontFamily,
                fontSize: _fontSize,
                lineHeight: _lineHeight,
                fontColor: _fontColor,
                fontStyle: '300',
                display: true
            }
        }],
    },
    elements: {
        point:{
            hitRadius: 10,
            borderColor: '#000',
            backgroundColor: 'rgba(255,255,255)'
        },
        line: {
            borderWidth: 0
        }
    },
    legend: {
        display: false
    },
    onResize: function(chart, size){
        handleResize(chart,size);
    }
}